<template>
  <div class="container">
    <div class="repair-status">
      <DefBreadCrumbs :result="result.breadcrumbs" />
      <div class="repair-status-header">
        <div>
          <DefTitle :result="1">
            <h1>
              {{ result.messages.orderNumber + ' ' + result.response.repairNumber }}
            </h1>
          </DefTitle>

          <p v-if="0" class="repair-status-header__text">
            Очікувана дата виконання
            <span class="repair-status-header__end">19.12.2022</span>
          </p>
        </div>

        <DefLink @click="checkAnotherNumber">
          {{ result.messages.checkAnotherNumber }}
        </DefLink>
      </div>
      <RepairStatusItem :result="result" />
    </div>
  </div>

  <div v-if="!isAuthorized" class="container-secondary">
    <RegistrationBanner :messages="result.messages" />
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import DefBreadCrumbs from '@components/Def/DefBreadCrumbs/DefBreadCrumbs.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefLink from '@components/Def/DefLink/DefLink.vue';
import RepairStatusItem from '@components/Cabinet/Repair/RepairStatus/RepairStatusItem/RepairStatusItem.vue';
import RegistrationBanner from '@components/RegistrationBanner/RegistrationBanner.vue';
import { useStore } from '@store';

const { result } = defineProps(['result']);
const { state, dispatch } = useStore();
const isAuthorized = computed(() => state.personal.data.authInfo.isAuthorized);
const checkAnotherNumber = async () => {
  await dispatch('repair/checkAnotherNumber');
};
</script>

<script>
export default {
  name: 'RepairStatus',
  components: {},
};
</script>

<style lang="scss" scoped>
.repair-status {
  margin-bottom: 64px;
  @include point-lg {
    margin-bottom: 80px;
  }

  :deep {
    .def-bread-crumbs {
      margin-bottom: 12px;
    }
  }
}

.repair-status-header {
  margin-bottom: 24px;
  @include point-md {
    display: flex;
    justify-content: space-between;
  }

  .def-title-1 {
    margin-bottom: 8px;
  }

  &__text {
    letter-spacing: 0.06em;
    color: #5f5f67;
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 16px;
    @include point-md {
      margin-bottom: 0;
    }
  }

  &__end {
    color: #689575;
    margin-left: 8px;
  }
}
</style>
